import { useSite } from "@/context/SiteContext";
import { waLink } from "@/lib/api";
import { fbEvent } from "@/lib/consent";

const WaIcon = () => (
  <svg viewBox="0 0 32 32" className="h-7 w-7" fill="currentColor" aria-hidden="true">
    <path d="M16.04 3C9.4 3 4 8.36 4 14.97c0 2.11.56 4.17 1.62 5.99L4 29l8.25-1.6a12.1 12.1 0 0 0 3.79.6C22.67 28 28 22.64 28 16.03 28 9.42 22.67 3 16.04 3Zm0 22.86c-1.2 0-2.38-.2-3.5-.6l-.25-.09-4.9.95.97-4.73-.17-.27a9.78 9.78 0 0 1-1.52-5.15c0-5.43 4.44-9.85 9.37-9.85 5.32 0 9.66 4.42 9.66 9.85 0 5.44-4.34 9.89-9.66 9.89Zm5.3-7.36c-.29-.15-1.72-.85-1.99-.94-.27-.1-.46-.15-.65.15-.2.29-.75.94-.92 1.13-.17.2-.34.22-.63.07-.29-.15-1.22-.45-2.33-1.43-.86-.76-1.44-1.7-1.61-1.99-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.2-.29.29-.49.1-.2.05-.37-.02-.51-.07-.15-.65-1.57-.9-2.15-.23-.56-.47-.49-.65-.5h-.55c-.2 0-.51.07-.78.37-.27.29-1.02 1-1.02 2.42 0 1.43 1.05 2.81 1.19 3 .15.2 2.06 3.13 4.99 4.39.7.3 1.24.48 1.67.61.7.22 1.34.19 1.84.12.56-.08 1.72-.7 1.97-1.38.24-.68.24-1.26.17-1.38-.07-.12-.27-.2-.56-.34Z" />
  </svg>
);

export const WhatsAppFloat = () => {
  const { settings } = useSite();
  if (!settings?.whatsapp) return null;
  return (
    <a
      href={waLink(settings.whatsapp, `Hi ${settings.brand_name}, I'd like to know more about your services.`)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => fbEvent("Contact", { method: "whatsapp" })}
      className="fixed bottom-5 right-5 z-50 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-lift transition-transform duration-200 hover:scale-110"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-float-btn"
    >
      <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-25" aria-hidden="true" />
      <WaIcon />
    </a>
  );
};
